var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container markdown-body",class:{ hidden: _vm.show },domProps:{"innerHTML":_vm._s(this.courseInfo)}}),_c('div',{staticClass:"task"},[_c('Exercise',{class:{ hidden: _vm.show },attrs:{"task":_vm.task}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }